import PropTypes from "prop-types"
import React from "react"
import SDSUPhoto from "./staticQuery.js/SDSUPhoto"
import DanaPhoto from "./staticQuery.js/DanaPhoto"

class Main extends React.Component {
  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      ></div>
    )

    return (
      <div
        ref={this.props.setWrapperRef}
        id="main"
        style={this.props.timeout ? { display: "flex" } : { display: "none" }}
      >
        <article
          id="education"
          className={`${this.props.article === "education" ? "active" : ""} ${
            this.props.articleTimeout ? "timeout" : ""
          }`}
          style={{ display: "none" }}
        >
          <h2 className="major">Education</h2>
          <span className="image main">
            <SDSUPhoto />
          </span>
          <h3 className="major">Professional Affiliations:</h3>
          <p>
            <em>
              - California Association of Marriage and Family Therapy, Clinical
              Member
            </em>
          </p>
          <p>
            <em>
              - International Center for Excellence in Emotionally Focused
              Therapy, Clinical Member
            </em>
          </p>
          <h3 className="major">Professional and Clinical Training:</h3>
                 <p>
            <em>- Emotionally Focused Therapy Externship San Diego, ICEEFT</em>
          </p>
                 <p>
            <em>- Emotionally Focused Therapy Externship Las Vegas, ICEEFT</em>
          </p>
                 <p>
            <em>- Emotionally Focused Therapy CORE Skills, ICEEFT</em>
          </p>
                 <p>
            <em>
              - Emotionally Focused Therapy Attachment Injury Repair Model
              Training (AIRM)
            </em>
          </p>
          <p>
            <em>
              - Emotionally Focused Individual Therapy and Trauma, ICEEFT
            </em>
          </p>
                <p>
            <em>
              - Accelerated Experiential Dynamic Psychotherapy Immersion
            </em>
          </p>
                 <p>
            <em>
              - Accelerated Experiential Dynamic Psychotherapy Essential Skills
            </em>
          </p>
                 <p>
            <em>
              - Accelerated Experiential Dynamic Psychotherapy Advanced Training
            </em>
          </p>
          <hr />
          <h3 className="major">San Diego State University</h3>
          <h4>
            <em>
              M.S. in Counseling, Marriage, and Family Therapy / Counseling
            </em>
            <br />
          </h4>
          {close}
        </article>

        <article
          id="about"
          className={`${this.props.article === "about" ? "active" : ""} ${
            this.props.articleTimeout ? "timeout" : ""
          }`}
          style={{ display: "none" }}
        >
          <h2 className="major">About</h2>
  
          <p style={{ textAlign: "center" }}>
            <em>
              “Owning our story can be hard but not nearly as difficult as
              spending our lives running from it. Embracing our vulnerabilities
              is risky but not nearly as dangerous as giving up on love and
              belonging and joy—the experiences that make us the most
              vulnerable. <br />
              Only when we are brave enough to explore the darkness will we
              discover the infinite power of our light.” <br />- Brené Brown
            </em>
          </p>
          <p>
           Life can often feel overwhelming, especially when you’re doing everything “right” yet still feel disconnected, stressed, or stuck. Whether you’re dealing with the pressures of a demanding job, navigating relationship challenges, or managing the various responsibilities of adulthood, finding time for yourself can be difficult. If you’re reading this, you may already sense that something needs to change and recognizing that is a significant first step.
          </p>
          <p>
           Hi, I’m Dana, a Licensed Marriage and Family Therapist based in San Diego, California. As a Licensed Marriage and Family Therapist and former IT project manager, I specialize in working with high-functioning, high-achieving professionals who are juggling demanding careers, relationships, and the desire for personal growth. Many of the individuals I work with typically in their early 30s to early 50s come from high-pressure industries like tech, healthcare, education, law, finance, and corporate settings. Whether they’re navigating burnout, dating or marital challenges, or simply feeling disconnected from themselves, therapy can be a space to slow down, grow, and reconnect.
          </p>
          <p>
           Individual therapy with me is about creating space to build self awareness, emotional intelligence/regulation, and reconnect with who you are beneath the roles and responsibilities. Whether you’re working through anxiety, trying to find more balance in your life, or wanting to build confidence and emotional clarity, we’ll explore what’s keeping you stuck and help you move forward in a grounded, sustainable way.
          </p>
          <p>
            I also work with couples who are committed to growing together, care about their relationship and want to make it stronger. Some of the couples I work with struggle with communication issues, feelings of disconnection, trust or intimacy. Others may be navigating tough seasons like infidelity, grief, loss, IVF, lack of intimacy or the complexities of wedding planning. And sometimes, it’s just about wanting to understand each other better and feel more like a team again.
          </p>
          <p>Starting therapy can seem daunting, but you don’t need to have everything figured out to begin. I offer both virtual and in-person sessions to accommodate your schedule and comfort level. If any of this resonates with you, please reach out. You deserve support that meets you where you are.</p>
          {close}
        </article>

        <article
          id="contact"
          className={`${this.props.article === "contact" ? "active" : ""} ${
            this.props.articleTimeout ? "timeout" : ""
          }`}
          style={{ display: "none" }}
        >
          <h2 className="major">Contact</h2>
          <form
            key="contact-form"
            name="contact form"
            method="POST"
            action="/#"
            data-netlify-honeypot="full-name"
            data-netlify="true"
          >
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="contact form" />
            <div style={{ display: "none" }}>
              <input type="text" id="full-name" name="full-name" />
            </div>
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" maxLength="50" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="email" name="email" id="email" maxLength="30" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea
                name="message"
                id="message"
                rows="4"
                maxLength="300"
              ></textarea>
            </div>
            <ul className="actions">
              <li>
                <input type="submit" value="Send Message" className="special" />
              </li>
              <li>
                <input type="reset" value="Reset" />
              </li>
            </ul>
          </form>
          <h5 className="major">Connect with me online</h5>
          <ul className="icons">
            {/* <li>
              <a
                href="https://twitter.com/HuntaroSan"
                className="icon fa-twitter"
              >
                <span className="label">Twitter</span>
              </a>
            </li> */}
            <li>
              <a
                href="https://www.instagram.com/dana.pasculescu.amft/"
                className="icon fa-instagram"
              >
                <span className="label">Instagram</span>
              </a>
            </li>
          </ul>
          {close}
        </article>
      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
